/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductStagingRequestDTOFromJSON, ProductStagingRequestDTOToJSON, } from './ProductStagingRequestDTO';
/**
 * Check if a given object implements the CreateProductUpdateJobsFromStagingRequestDTO interface.
 */
export function instanceOfCreateProductUpdateJobsFromStagingRequestDTO(value) {
    return true;
}
export function CreateProductUpdateJobsFromStagingRequestDTOFromJSON(json) {
    return CreateProductUpdateJobsFromStagingRequestDTOFromJSONTyped(json, false);
}
export function CreateProductUpdateJobsFromStagingRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'productStagingIds': json['productStagingIds'] == null ? undefined : json['productStagingIds'],
        'filters': json['filters'] == null ? undefined : ProductStagingRequestDTOFromJSON(json['filters']),
    };
}
export function CreateProductUpdateJobsFromStagingRequestDTOToJSON(json) {
    return CreateProductUpdateJobsFromStagingRequestDTOToJSONTyped(json, false);
}
export function CreateProductUpdateJobsFromStagingRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'selectAll': value['selectAll'],
        'productStagingIds': value['productStagingIds'],
        'filters': ProductStagingRequestDTOToJSON(value['filters']),
    };
}
